import messages from '../../../locale/messages';

const validate = values => {
    const errors = {};

    if (!values.title) {
        errors.title = messages.required;
    } else if (values.title.length > 100) {
        errors.title = messages.exceedLimit100;
    }

    if (!values.message) {
        errors.message = messages.required;
    } else if (values.message.length > 500) {
        errors.message = messages.exceedLimit500;
    }

    return errors;
}

export default validate;